import { useRive, Layout, Fit, Alignment } from '@rive-app/react-canvas';

export default function RiveTitle({...props}) {
  const { rive, RiveComponent } = useRive({
    src: '/assets/mixed2.riv',
    autoplay: true,
    loop: true,
    layout: new Layout({
      fit: Fit.Contain,
      alignment: Alignment.TopCenter,
    }),
  });

  return (
    <RiveComponent

      onMouseEnter={() => rive && rive.play()}
      onMouseLeave={() => rive && rive.pause()}
    />
  );
}